import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

import NoResults from './NoResults'
import Products from './Products'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import BottomToolbar from './BottomToolbar'
import Loader from './Loader'

import { checkReviews, removeEmptyElements } from "../helpers"

export default () => {
    const {
        response: { products }, query: { query },
        loading,
    } = useAppState()

    const foundProducts = products && products.total > 0

    const [showFilters, setShowFilters] = useState(false)
    const [selectedItems, setSelectedItems] = useState([]);
    const [clickedFacet, setClickedFacet] = useState(null);

    const handleClickFilters = (facet = null) => {
        setShowFilters(!showFilters);
        setClickedFacet(facet)
    }

    // useEffect(() => {
    //     if (!loading) {
    //         checkReviews().then(() => {
    //             setTimeout(() => removeEmptyElements(), 1000)
    //         });
    //     }
    // }, [loading])

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                checkReviews()
            }, 1500);
        }
    }, [loading])

    return (
        <div class="ns-serp ns-d-flex ns-flex-column ns-font-inherit ns-p-4 ns-my-0 ns-mx-auto" data-nosto-element="search">
            {!loading && query && (
                <div class="ns-query-result">
                    <h2>Search results for "{query}"</h2>
                </div>
            )}

            {(foundProducts || (loading && foundProducts)) && (
                <Fragment>
                    <Toolbar
                        mobile={true}
                        showFilters={showFilters}
                        setShowFilters={setShowFilters}
                        handleClickFilters={handleClickFilters}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        setClickedFacet={setClickedFacet}
                    />
                </Fragment>
            )}
            <div
                class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0 ns-pl-md-5"
                style={loading ? 'position: relative;' : ''}
            >
                {foundProducts ? (
                    <>
                        <Toolbar
                            mobile={false}
                            showFilters={showFilters}
                            setShowFilters={setShowFilters}
                            handleClickFilters={handleClickFilters}
                            selectedItems={selectedItems}
                            setSelectedItems={setSelectedItems}
                        />
                        <div style="display: flex">
                            <Sidebar
                                showFilters={showFilters}
                                setShowFilters={setShowFilters}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}
                                clickedFacet={clickedFacet}
                                setClickedFacet={setClickedFacet}
                            />
                            <Products />
                        </div>
                        <BottomToolbar />
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}
